var BaseViews = require('../base');
var Spinner = require('treeline-shared-components/spinner');
require('./cart-loading/cart-loading.scss');

var CartLoading = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-loading',
    template: require('./cart-loading/cart-loading.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'light'
            }
        );
    },
    regions: {
        loadingIndicatorRegion: '.fmcy-cart-loading-indicator-region'
    },
    _renderLoader: function () {
      this._spinner = new Spinner();
      this.loadingIndicatorRegion.show(this._spinner);
    },
    onRender: function() {
      var self = this;
      this._renderLoader();
      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onDestroy: function () {
      BaseViews.LayoutView.prototype.onDestroy.call(this);
    }
});

module.exports = CartLoading;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-loading.js
 **/